
import { SistemaMixin } from "@/modules/Application";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Eye from "vue-material-design-icons/Eye.vue";
import Download from "vue-material-design-icons/Download.vue";
import Upload from "vue-material-design-icons/Upload.vue";

export default {
  name: "app-conciliacao-bancaria-lista",
  mixins: [SistemaMixin],
  components: {
    TrashCanIcon,
    Eye,
    Download,
    Upload,
  },
  data() {
    return {
      isLoading: false,
      conciliacoes: [],
      filtros: {
        banco: "",
        status: "",
        data_inicio: "",
        data_fim: "",
      },
    };
  },
  computed: {
    conciliacoesFiltradas() {
      return this.conciliacoes.filter((item) => {
        const matchBanco =
          !this.filtros.banco ||
          (item.banco_nome || "")
            .toLowerCase()
            .includes(this.filtros.banco.toLowerCase());
        const matchStatus =
          !this.filtros.status || item.status === this.filtros.status;
        const matchInicio =
          !this.filtros.data_inicio ||
          item.data_importacao >= this.filtros.data_inicio;
        const matchFim =
          !this.filtros.data_fim ||
          item.data_importacao <= this.filtros.data_fim;
        return matchBanco && matchStatus && matchInicio && matchFim;
      });
    },
  },
  mounted() {
    this.fetchConciliacoes();
  },
  methods: {
    async fetchConciliacoes() {
      this.isLoading = true;
      try {
        const { data } = await this.$http.post("/conciliacao-bancaria/lista");
        // Aceita ambos os formatos: array direto ou { data: [...] }
        this.conciliacoes = Array.isArray(data) ? data : (data.data ?? []);
      } catch (error) {
        this.$toast.error("Erro ao carregar as conciliações bancárias.");
      } finally {
        this.isLoading = false;
      }
    },
    filtrar() {
      // Reatividade via computed já aplica os filtros automaticamente
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      return d.toLocaleDateString("pt-BR");
    },
    getProgressVariant(percent) {
      if (percent >= 100) return "success";
      if (percent >= 50) return "warning";
      return "danger";
    },
    getTextVariant(percent) {
      if (percent >= 100) return "text-success";
      if (percent >= 50) return "text-warning";
      return "text-danger";
    },
    getBadgeClass(status) {
      const map = {
        pendente: "badge badge-warning",
        parcial: "badge badge-info",
        concluido: "badge badge-success",
      };
      return map[status] || "badge badge-secondary";
    },
    getLabelStatus(status) {
      const map = {
        pendente: "Pendente",
        parcial: "Parcial",
        concluido: "Concluído",
      };
      return map[status] || status;
    },
    excluirConciliacao(item) {
      this.$swal
        .fire({
          icon: "warning",
          title: `Excluir a conciliação do banco ${item.banco_nome}?`,
          text: "Esta ação não poderá ser desfeita.",
          showCancelButton: true,
          confirmButtonText: "Sim, excluir",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.$http.post("/conciliacao-bancaria/delete", {
                id_conciliacao: item.id_conciliacao,
              });
              this.$toast.success("Conciliação excluída com sucesso!");
              this.fetchConciliacoes();
            } catch (error) {
              this.$toast.error("Erro ao excluir a conciliação.");
            }
          }
        });
    },
    abrirDetalheConciliacao(item) {
      this.$router.push({ name: 'conciliacaoBancariaDetalhe', params: { id: item.id_conciliacao } });
    },
  },
};
